export type ReviewPropsTypes = {
    name: string;
    rating: 1 | 2 | 3 | 4 | 5;
    feedback: string[];
};

export type BeehaveReviewProps = {
    code_quality_improvements: string[];
    code_quality_score: 1 | 2 | 3 | 4 | 5;
    documentation_improvements: string[];
    documentation_score: 1 | 2 | 3 | 4 | 5;
    functionality_improvements: string[];
    functionality_score: 1 | 2 | 3 | 4 | 5;
    test_coverage_improvements: string[];
    test_coverage_score: 1 | 2 | 3 | 4 | 5;
};

export enum ContributorWorkSteps {
    TaskAccept = 'TASK_ACCEPT',
    WorkingOnPullRequest = 'WORKING_ON_PULL_REQUEST',
    SubmitPullRequest = 'SUBMIT_PULL_REQUEST', 
    DescriptionFeedback = 'DESCRIPTION_FEEDBACK',
    QuestReviewModifications = 'QUEST_REVIEW_MODIFICATIONS',
    Done = 'DONE',
}

export enum ContributorReviewSteps {
    TaskAccept = 'TASK_ACCEPT',
    TaskReview = 'TASK_REVIEW',
    TaskReviewDone = 'TASK_REVIEW_DONE', 
}
